export default __webpack_public_path__ + "static/trash-removal-icon-b4bf0c371e8f00418a4aa175d3948490.png";